import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { SocioManager } from '../../application/managers/socio.manager';
import { CRUDHnadler } from '../../domain/repositories/general/crud.handler';
import { Socio } from '../../domain/models/socio.model';
import { environment } from 'environments/environment';

/**
 *Adaptador de las implementaciones de dominio y conexión directa con los servicios de recuperación
 *
 * @export
 * @class SocioAdapter
 * @implements {CRUDHnadler}
 */
export class SocioAdapter implements CRUDHnadler {
  private apiUrl = ``;

  constructor(private http: HttpClient) {}

  save(socio: Socio): Observable<Socio> {
    return this.http.post<Socio>(this.apiUrl, socio);
  }

  findById(id: number): Observable<Socio> {
    const url = ``;
    return this.http.get<Socio>(url);
  }

  findAll(): Observable<Socio[]> {
    let ruta = environment.partnerList;
    return this.http.get<Socio[]>(ruta);
  }

  update(id: number, socio: Socio): Observable<Socio> {
    const url = ``;
    return this.http.put<Socio>(url, socio);
  }

  deleteById(id: number): Observable<boolean> {
    const url = ``;
    return this.http.delete<boolean>(url);
  }
}
